document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".js-infinite-scroll");
  const pagination = document.querySelector(".pagination");
  const loader = document.querySelector(".shop-now__loader");

  if (!container || !pagination) return;

  let nextURL = pagination.querySelector("a[rel=next]")?.href;
  let isLoading = false;

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && nextURL && !isLoading) {
      isLoading = true;
      loader.style.display = "block";

      fetch(nextURL)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");

          // Grab products from next page
          const newProducts = doc.querySelectorAll(".shop-now__product");
          newProducts.forEach(el => container.insertBefore(el, pagination));

          // Update pagination
          const newPagination = doc.querySelector(".pagination");
          nextURL = newPagination?.querySelector("a[rel=next]")?.href || null;

          if (!nextURL) {
            pagination.remove();
            observer.disconnect();
          }

          loader.style.display = "none";
          isLoading = false;
        })
        .catch(err => {
          console.error("Infinite scroll error:", err);
          loader.style.display = "none";
          isLoading = false;
        });
    }
  }, { threshold: 1.0 });

  observer.observe(pagination);
});
